import { useTheme } from 'tamagui'
import { useFeatureGate } from '@/src/services/Statsig/useFeatureGate'
import * as Statsig from '../statsig'

export function usePrimaryColor() {
  const theme = useTheme()
  const useNewColorSchemeFeatureGate = useFeatureGate(Statsig.FeatureGate.UseNewColorScheme)
  const isNewColorScheme =
    useNewColorSchemeFeatureGate.loadingStatus === 'Ready' &&
    useNewColorSchemeFeatureGate.featureGate.value

  return {
    isNewColorScheme,
    colorValue: isNewColorScheme ? theme.primary.val : theme.oldPrimary.val,
    token: isNewColorScheme ? '$color.primary' : '$color.oldPrimary',
  } as const
}
